import React, { useContext } from 'react'
import styled from 'styled-components'
import { SalleContext } from '../../context/salle'

const CardWrapper = styled.div`
    cursor: pointer;
    margin-top: 1.0rem;
    margin-bottom: 1.2rem;
    min-height: 30px;    
    table th,td{
        
        font-family: "Poppins";
        font-weight: 500;
        padding: 0.5rem;
    }


    table thead,tbody{
        border-bottom: 1px solid black;
    }

    tbody tr > td{
        max-width: 410px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }



`

const TableDataTiny = ({option}) => {

    const { products,setModalSalle } = useContext(SalleContext)

    return (
        <CardWrapper onClick={() => setModalSalle(true)}>

            <table>
                <thead>
                    <td>Nº</td>
                    <td>Descrição</td>
                    <td>Código (SKU)</td>
                    <td>{option == 2 ? "Base" : option == 3 ? "MVA %" : "Qtde" }</td>
                    <td>{option == 2 ? "Valor desconto	" : option == 3 ? "ICMS ST %" : "UN" } </td>
                    <td>{option == 2 ? "%" :option == 3 ? "ICMS ST R$	" :  "Preço un" }</td>
                    <td>{option == 2 ? "Valor comissão" : option == 3 ? "FCP ST %" : "Preço total"}</td>
                    {option == 3 ? <td>FCP ST R$</td> : ""}
                    {option == 3 ? <td>IPI %</td> : ""}

                </thead>

                <tbody>

                    {products?.map(item => {
                        return (
                            <tr>
                                <td>{item.id}</td>
                                <td>{item.name_product}</td>
                                <td>{item.sku}</td>
                                <td>{option == 2 ?  Number(item.price).toLocaleString("pt-BR",{minimumFractionDigits:2})  :  option == 3 ? "0,00" :  item.quantity}</td>
                                <td>{option == 2 ? "0,000000" : option == 3 ? "0,00" : "UN" }</td>
                                <td>{option == 2 ? "0,00" : option == 3 ? "0,00": Number(item.price).toLocaleString("pt-BR",{minimumFractionDigits:2}) }</td>
                                <td>{option == 2 ? "0,00" : option == 3 ? "0,00" : Number(item.price).toLocaleString("pt-BR",{minimumFractionDigits:2}) }</td>
                                {option == 3 ? <td>0,00</td> : <></>}
                                {option == 3 ?<td>0,00</td> : <></>}

                            </tr>
                        )
                    })}


                </tbody>

            </table>

        </CardWrapper>
    )
}

export default TableDataTiny